import { Directive, Input, TemplateRef, ViewContainerRef, OnInit } from '@angular/core';
import { PermissionService } from '../../services/permission-service'

@Directive({
    selector: '[appHasPermission]'
})
export class HasPermissionDirective {
    private requiredPermission!: string;

    constructor(
        private tpl: TemplateRef<any>,
        private vcr: ViewContainerRef,
        private ps: PermissionService
    ) { }

    @Input()
    set appHasPermission(permission: string) {
        this.requiredPermission = permission;
        this.updateView();
    }

    private updateView() {
        if (this.ps.has(this.requiredPermission)) {
            this.vcr.createEmbeddedView(this.tpl);
        } else {
            this.vcr.clear();
        }
    }
}
